import { RequestPostImportCsvData } from '../types/importCsv'
import ApiClient from './apiClient'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const downloadCsv = async (code: string): Promise<any> => ApiClient.getFile(
  '/api/v1/features/import/csv/company/download',
  (result) => result,
  { code: code },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCsvData = async (file: string): Promise<any> => ApiClient.getWithFile(
  '/api/v1/features/import/csv/company/upload',
  (result) => result,
  file,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postCsvData = async (params: RequestPostImportCsvData): Promise<any> => ApiClient.post(
  '/api/v1/features/import/csv/company/upload',
  (result) => result,
  params,
)
